import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPSLListAPI = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/psl`,
    method: 'get',
  });
};

export type PSLListResponse = {
  lookupCodeId: string; // 'AL'
  displayValue: string; // 'AL - Artificial Lift'
}[];

export const fetchPSLList = async (): Promise<PSLListResponse> => {
  const response: AxiosResponse<PSLListResponse> = await getPSLListAPI();
  return response.data;
};
